// Module
var code = "<p>Etkin izinler, bu hesaptaki fonları harcamaya izni olan hesapları belirler.</p> <p>Etkin izinler kolay bir şekilde çok-imzalı bir düzen kurmak için kullanılabilirler, daha fazla bilgi için <a href=\"accounts/permissions\">izinler</a> bölümüne bakabilirsiniz.</p> ";
// Exports
export default code;